import { gql } from 'urql';

export const mutationRemoveDirectory = gql`
  mutation RemoveDirectory($directoryId: String!) {
    removeDirectory(directoryId: $directoryId)
  }
`;
